import { Component, OnInit, ViewChild, Input, Injectable, Inject } from '@angular/core';
import { FormsModule, Validators } from '@angular/forms';
import { User } from '../../models/user';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule, NgOption } from '@ng-select/ng-select';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { SeeInvoicesService } from './../../services/see-invoices/see-invoices.service';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { containsTree } from '@angular/router/src/url_tree';
import { GeneralService } from './../../services/admin/general.service';
import { StorageService } from '../../services/storage.service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';

const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};


@Injectable()
export class I18n {
  lang; language;
  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }
  }
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}


@Component({
  selector: 'app-seeinvoices',
  templateUrl: './see-invoices.component.html',
  styleUrls: ['./see-invoices.component.scss'],
  providers: [GeneralService, CatalogsService, SeeInvoicesService,
    I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class SeeInvoicesComponent implements OnInit {
  public user: User;
  rol;
  @ViewChild('mydatatable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  rows = [];
  proveedores;
  sociedades;
  proveedorFilter = '';
  sociedadFilter = '';
  fechai;
  fechaf;
  facturas;
  closeResult: string;
  modalConfirmation;
  modalRespuesta;
  index;
  respuestaSC;
  titulo;
  mensaje;
  busy: boolean = false;
  busyBusqueda: boolean = false;
  busyCargar: boolean = false;

  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();

  flagVacio;
  toastRangoFechasValido;
  camposObligatorios;
  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private catalogs: CatalogsService,
    private seeInvoices: SeeInvoicesService,
    private modalService: NgbModal,
    private toasterService: ToasterService,
    private storageService: StorageService,
  ) {
    this.getProveedores();
  }

  ngOnInit() {
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.toastCamposObligatorios').subscribe(
      text => {
        this.camposObligatorios = text;
      });

    this.translate.get('texto.rangoFechasValido').subscribe(
      text => {
        this.toastRangoFechasValido = text;
      });

    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.modulo();
    this.rol = this.user.rol.id;
    this.getSociedades();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Ver facturas').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  getProveedores() {
    this.proveedores$ = concat(of([]),
      this.proveedorinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.proveedoresLoading = true),
        switchMap(term =>
          this.catalogs.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoading = false)
          ))
      )
    );
  }

  getSociedades() {
    this.busy = true;
    this.catalogs.obtenerSociedades().subscribe(
      data => {
        this.busy = false;
        this.sociedades = data.sapSociedad;
      },
      err => {

        // console.log(err);

      },
    );
  }

  getFacturas() {
    var flagVerFacturas = false;
    let sociedad = this.sociedadFilter;
    let usuario = this.proveedorFilter;
    let fechaDesde = (<HTMLInputElement>document.getElementById('fechaiOpt')).value;
    let fechaHasta = (<HTMLInputElement>document.getElementById('fechafOpt')).value;

    if (usuario === undefined || usuario === null) {
      usuario = '';
    }
    if (sociedad === undefined || sociedad === null) {
      sociedad = '';
    }
    if (fechaDesde === undefined || fechaDesde === null) {
      fechaDesde = '';
    }
    if (fechaHasta === undefined || fechaHasta === null) {
      fechaHasta = '';
    }

    if (usuario === '' || sociedad === '' || fechaDesde === '' || fechaHasta === '') {
      this.toasterService.pop('error', 'ERROR', this.camposObligatorios);
      flagVerFacturas = false;
    } else {
      if (fechaDesde != '' && fechaHasta != '') {
        if (fechaDesde <= fechaHasta) {
          flagVerFacturas = true;
        } else {
          flagVerFacturas = false;
          this.toasterService.pop('error', 'ERROR', this.toastRangoFechasValido);
        }
      } else {
        flagVerFacturas = true;
      }
    }

    if (flagVerFacturas) {
      this.busyBusqueda = true;
      this.seeInvoices.obtenerFacturas(usuario, fechaDesde, fechaHasta, sociedad).subscribe(
        data => {
          this.busyBusqueda = false;
          this.facturas = data.estadoCtaProveedor;
          this.rows = this.facturas;
        },
        err => {
          this.busyBusqueda = false;
          if (err.status === 401) {
            this.storageService.openLogout();
          }
        },
      );
    }
  }

  openConfirmation(content, i) {
    this.index = i;
    this.modalConfirmation = this.modalService.open(content, { centered: true, backdrop: 'static' });
    this.modalConfirmation.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  solicitarComplemento(respuesta) {
    this.busyCargar = true;
    const output = {
      fechaDePago: this.facturas[this.index].fecha,
      noDocumento: this.facturas[this.index].numeroDoc,
      proveedor: this.proveedorFilter,
      total: this.facturas[this.index].importeDoc
    };
    const json = JSON.stringify(output);

    this.seeInvoices.solicitarComplemento(json).subscribe(
      data => {

        this.busyCargar = false;
        this.mensaje = data.result.message;
        this.getFacturas();
        this.modalConfirmation.close();
        this.respuesta(respuesta);

      },
      err => {
        this.busyCargar = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );

  }


  respuesta(respuesta) {
    this.modalRespuesta = this.modalService.open(respuesta, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalRespuesta.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissR(reason)}`;
    });
  }

  private getDismissR(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}







// WEBPACK FOOTER //
// ./src/app/pages/see-invoices/see-invoices.component.ts